import React from 'react'
import { grey } from 'lib/theme'

import CategoryTagLink from 'components/ProfilePage/Categories/CategoryTagLink'

import { CategoryProps } from '../type'

type CategoryPropsProps = {
  category: CategoryProps
}

const Category: React.FC<CategoryPropsProps> = ({ category }) => {
  if (!category) {
    return null
  }
  const { title, color = grey, linkPath = null, profileCollection } = category

  return (
    <CategoryTagLink
      {...{ linkPath, profileCollectionSlug: profileCollection }}
      categoryTag={{ color, title }}
    />
  )
}

export default Category
